// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "460" ? "quickjs-sandbox" : chunkId) + "." + {"396": "db91786e64f839af","460": "877b9daac7343a75","917": "09ff679c2691d90a","985": "4f283e702a2b4b7b",}[chunkId] + ".chunk.js"
}